<!--
 * @Author: klein
 * @Date: 2021-09-23 15:02:24
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2021-12-29 16:09:08
 * @FilePath: \planApp\src\App.vue
-->
<template>
  <div id="app">
    <router-view v-if="showView" />
  </div>
</template>

<script>
import axios from 'axios'
import Helper from './common/helper'
import { billingApiBase } from './api/billingBase'
import Vue from 'vue'
// import { updateRouter } from './router'

export default {
  name: 'App',
  components: {},
  data () {
    return {
      showView: false,
      site: ''

    }
  },
  created () {
    this.getTheme()
  },
  mounted () {
    this.getInfo()
  },
  computed: {
    logOutUrl () {
      return this.$store.state.initMsg.logOutUrl
    },
    isGoApp () {
      return window.location.hostname.includes('go.tvunetworks.com')
    }
  },
  methods: {
    getTheme () {
      const theme = Helper.getCookie('theme') || 'dark'
      window.document.body.classList.add(theme)
      this.$store.commit('saveTheme', theme)
    },
    getLanguage () {
      const lg = Helper.getCookie('userLanguage') || 'en'
      this.$i18n.locale = lg
    },
    changeLanguage (lg) {
      this.$i18n.locale = lg
    },
    getInfo () {
      axios.get(`${billingApiBase()}/base/init`, {
        withCredentials: true
      }).then(res => {
        const { serviceAuthName, chargebeeSitName, stripePublishKey, userAuthUrl, userServiceUrl, newUserServiceUrl = '' } = res.data
        window.CONFIG.redirect = this.isGoApp ? newUserServiceUrl + '/' : userServiceUrl + '/'
        window.CONFIG.stripePublishKey = stripePublishKey
        window.CONFIG.getEmailPath = userAuthUrl + '/main/GetInfoJSON'
        this.site = chargebeeSitName
        this.serviceAuthName = serviceAuthName
        const _userAuthUrl = new URL(userAuthUrl)
        Vue.prototype.$TVU.userAuthUrl = _userAuthUrl.hostname + _userAuthUrl.pathname
        console.log(window.location)

        this.$store.commit('saveInitMsg', {
          ...res.data,
          logOutUrl: this.getLogoutUrl()
        })
        this.getEmailIdBasedOnSession(res.data)
      })
    },
    getEmailIdBasedOnSession (billingInitMsg) {
      axios.get(`${billingApiBase()}/user/info`, {
        withCredentials: true
      }).then(async (res) => {
        if (res.data.errorCode == '0x0') {
          this.emailid = res.data.result.email
          const groupRole = await this.getUserGroupRole()
          billingInitMsg.groupRole = groupRole
          this.$store.commit('saveUserInfo', res.data.result)
          // updateRouter(res.data.result.role, Helper.getEnv())
          this.showView = true
          // if (this.isGoApp) {

          // } else if (window.self === window.top && !location.pathname.includes('/dashboard')) {
          //   this.$router.push('/dashboard')
          // }

          this.handleIframe(billingInitMsg)
        } else if (res.data.errorCode == '0x80060005') {
          // window.location.replace(this.logOutUrl)
        }
      }).catch(err => {
        console.log(err.message)
        const message = err.message || ''
        if (message.includes('401')) {
          // const loginUrl = this.getLogoutUrl()
          // console.log('loginUrl -->', loginUrl)
          this.sessionexpired()
          window.location.replace(this.logOutUrl)
        }
      })
    },
    getLogoutUrl () {
      if (this.isGoApp) {
        return window.CONFIG.redirect + '?url=' + window.location.href + '&serviceName=' + this.serviceAuthName
      } else {
        return window.CONFIG.redirect + '?url=' + window.location.origin + window.location.pathname + '&serviceName=' + this.serviceAuthName
      }
    },
    // 0 member 1 admin 2 owner 3 finance
    getUserGroupRole () {
      return axios.get(`${billingApiBase()}/user/userGroupRole`).then(res => {
        if (res.data.errorCode == '0x0') {
          return res.data.result
        } else {
          return ''
        }
      }).catch(() => {
        return ''
      })
    },
    initChargeBee () {
      if (!window.Chargebee) {
        setTimeout(() => {
          this.initChargeBee()
        }, 3000)
        return
      }
      // const hostname = window.location.hostname
      // let site = 'tvunetworks-test'
      // if(hostname == "bill.tvunetworks.com") {
      //   site = 'tvunetworks'
      // }
      window.Chargebee.init({ site: this.site })
    },
    sessionexpired () {
      const params = {
        from: 'billing',
        type: 'step',
        data: {
          type: 'Session Expired',
          key: 'close'
        }
      }
      window.parent.postMessage(params, '*')
    },
    handleIframe (billingInitMsg) {
      setTimeout(() => {
        window.parent.postMessage({
          from: 'billing',
          type: 'init',
          data: billingInitMsg
        }, '*')
        this.handleIframeData()
      }, 100)
    },
    handleIframeData () {
      // this.$store.commit('handleIframeData', {
      //   product: 'Micro',
      //   result: {}
      // })
      window.addEventListener('message', e => {
        // if(e.origin === window.location.origin) return false
        try {
          const data = e.data
          if (data && data.from == 'billing') {
            console.log(data, 'zzzzzzzzzz')
            if (data && data.data && data.data.product == 'Language') {
              return this.changeLanguage(data.data.result)
            }
            this.$store.commit('handleIframeData', data.data)
            this.getLanguage()
          }
        } catch (error) {
          console.log(error)
        }
      })
    }
  }
}
</script>
<style lang="less">
@import './assets/front/iconfont.css';
@import './assets/init.css';
.el-message {
  top: 20vh !important;
}
.el-dialog__wrapper .el-dialog {
  background: var(--dialog-bg);
  .el-dialog__header {
    border-bottom-color: var(--dialog-border-color) !important;
    .el-dialog__title {
      color: var(--dialog-text-color);
    }
  }
  .el-input__inner {
    background-color: var(--dialog-input-bg);
    border-color: var(--dialog-input-border-color);
    color: var(--dialog-input-color);
  }
}
.el-loading-mask {
  background-color: var(--loading-bg) !important;
}
.el-select-dropdown.el-popper {
  background-color: var(--dialog-input-bg);
  border-color: var(--dialog-input-border-color);
  color: var(--dialog-input-color);
  .el-select-dropdown__item {
    color: var(--dialog-input-color);
    &.selected {
      color: #409EFF;
    }
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: var(--content-select-dropdown-hover-bg);
  }
}
.el-picker-panel.el-popper {
  color: var(--datepicker-text-color);
  background: var(--datepicker-bg);
  border-color: var(--datepicker-inner-border-color);
  .el-picker-panel__footer {
    background-color: var(--datepicker-bg);
    border-top-color: var(--datepicker-inner-border-color);
    .el-button {
      color: var(--table-button-text-color);
      border-color: var(--table-button-border-color);
      background-color: var(--table-button-bg);
    }
    .el-button--text {
      border: none;
    }
  }
  .el-date-range-picker__time-header {
    border-bottom-color: var(--datepicker-inner-border-color);
  }
  .el-input__inner {
    color: var(--datepicker-text-color);
    background: var(--datepicker-bg);
    border-color: var(--datepicker-inner-border-color);
  }
  .el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div {
    background-color: var(--datepicker-inrange-bg-color);
  }
  .el-time-spinner__item:hover:not(.is-disabled):not(.is-active) {
    background: var(--content-select-dropdown-hover-bg);
  }
  .el-time-panel {
    background: var(--datepicker-bg);
    border-color: var(--datepicker-inner-border-color);
    .el-time-spinner__item {
      color: var(--datepicker-text-color);
    }
    .el-time-panel__btn {
      color: var(--table-button-text-color);
      border-color: var(--table-button-border-color);
      background-color: var(--table-button-bg);
    }
    .el-time-panel__content::after, .el-time-panel__content::before {
      border-top-color: var(--datepicker-inner-border-color);
      border-bottom-color: var(--datepicker-inner-border-color);
    }
    .el-time-panel__footer {
      border-top-color: var(--datepicker-inner-border-color);
    }
  }
  &[x-placement^=bottom] .popper__arrow {
    border-bottom-color: var(--datepicker-bg);
    &::after {
      border-bottom-color: var(--datepicker-bg);
    }
  }
  .el-date-table th {
    border-bottom-color: var(--datepicker-inner-border-color);
  }
  .el-date-range-picker__content.is-left {
    border-right-color: var(--datepicker-inner-border-color);
  }
  .el-picker-panel__icon-btn {
    color: var(--datepicker-text-color);
  }
}
.whitelist-popover.el-popover {
  min-width: unset;
  background: var(--dialog-input-bg);
  border-color: var(--dialog-input-bg);
  color: var(--datepicker-text-color);
  .popper__arrow::after {
    border-right-color: var(--dialog-bg) !important;
  }
}
.el-select-dropdown {
  background-color: var(--dialog-input-bg);
  border: none;

  .el-select-dropdown__wrap {
    .el-select-dropdown__list {
      background-color: var(--dialog-bg);
      border-radius: 4px;

      .el-select-dropdown__item {
        font-size: 12px;
        color: var(--billing-ui-262626-dbdbdb);

        &.selected {
          background-color: var(--dialog-bg);
          font-weight: 700;
          color: #56af31;
        }

        &.hover {
          background-color: var(--billing-ui-606266-f5f7fa);
        }

        .select-item {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-inline-box;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          -webkit-line-clamp: 1;
          word-wrap: break-word;
          word-break: break-all;
        }
      }
    }
  }

  .el-select-dropdown__empty {
    background-color: #333;
    border-radius: 4px;
  }

  .popper__arrow {
    display: none;
  }
}
</style>
